import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl, baseimgUrl } from "../Univ";
import { Link } from "react-router-dom";

function Wishlist() {

  const [wishlist, setWishlist] = useState([]);

  useEffect(() => {
    fetchWishlist();
  }, []);

  // -------------------------
  // FETCH WISHLIST
  // -------------------------
  const fetchWishlist = async () => {
    const res = await axios.get(
      baseUrl + "wishlist/",
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      }
    );
    setWishlist(res.data);
  };

  // -------------------------
  // REMOVE WISHLIST
  // -------------------------
  const removeWishlist = async (id) => {
    await axios.post(
      baseUrl + "remove-wishlist/",
      { id },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      }
    );
    fetchWishlist();
  };

  return (
    <div className="container mt-4">

      <h3>My Wishlist</h3>

      {wishlist.length === 0 && <h5>No items</h5>}

      <div className="row">

        {wishlist.map((w) => (

          <div key={w.id} className="col-md-3 mb-4">

            <div className="card">

              <img
                src={`${baseimgUrl}${w.product.images?.[0]?.image || "https://via.placeholder.com/180x150?text=No+Image"}`}
                className="card-img-top"
                alt=""
                style={{ height: "180px", objectFit: "cover" }}
              />

              <div className="card-body">

                <h6>{w.product.name}</h6>

                <p>₹{w.product.price}</p>

                <Link
                  to={`/product/${w.product.id}`}
                  className="btn btn-sm btn-primary me-2"
                >
                  View
                </Link>

                <button
                  onClick={() => removeWishlist(w.id)}
                  className="btn btn-sm btn-danger"
                >
                  Remove
                </button>

              </div>

            </div>

          </div>

        ))}

      </div>

    </div>
  );
}

export default Wishlist;
